<svg 
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.63316 8.36617C6.32673 11.1962 9.05525 13.5062 12.3836 14.9562L14.971 12.7562C15.2885 12.4862 15.7589 12.3962 16.1706 12.5162C17.4878 12.8862 18.9109 13.0862 20.3692 13.0862C21.016 13.0862 21.5453 13.5362 21.5453 14.0862V17.5762C21.5453 18.1262 21.016 18.5762 20.3692 18.5762C9.32575 18.5762 0.375732 10.9662 0.375732 1.57617C0.375732 1.02617 0.904971 0.576172 1.55182 0.576172H5.66812C6.31497 0.576172 6.84421 1.02617 6.84421 1.57617C6.84421 2.82617 7.07942 4.02617 7.51458 5.14617C7.64395 5.49617 7.54986 5.88617 7.22055 6.16617L4.63316 8.36617Z" fill="#CAD1E1"/>
  </svg>
  